(()=>{const s=document.createElement("script");s.type="application/ld+json";s.textContent="{\"@context\": \"https://schema.org\", \"@type\": \"WebPage\", \"name\": \"Beer Gifts to Canada from Australia | BeerNGrub\", \"url\": \"https://beerngrub.ca/pages/send-beer-gifts-to-canada-from-australia\", \"description\": \"Shop BeerNGrub beer and food pairing boxes for Canada from Australia. Compare gifts and check address-specific delivery options.\", \"inLanguage\": \"en-CA\", \"isPartOf\": {\"@type\": \"WebSite\", \"name\": \"BeerNGrub Canada\", \"url\": \"https://beerngrub.ca\"}, \"breadcrumb\": {\"@type\": \"BreadcrumbList\", \"itemListElement\": [{\"@type\": \"ListItem\", \"position\": 1, \"name\": \"BeerNGrub\", \"item\": \"https://beerngrub.ca\"}, {\"@type\": \"ListItem\", \"position\": 2, \"name\": \"Australia\", \"item\": \"https://beerngrub.ca/pages/send-beer-gifts-to-canada-from-australia\"}]}}";document.head.appendChild(s);})();

/* Read-only postcode routing. An estimate is not an order-specific delivery date. */

(()=>{'use strict';const form=document.querySelector('.cp-checker-form');if(!form)return;const input=form.querySelector('input'),out=document.querySelector('.cp-result'),button=form.querySelector('button');const show=(text,error=false)=>{out.hidden=false;out.classList.toggle('error',error);out.textContent=text;};form.addEventListener('submit',async ev=>{ev.preventDefault();const raw=input.value.toUpperCase().replace(/[\s-]/g,'');if(!/^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTVWXYZ]\d[ABCEGHJ-NPRSTVWXYZ]\d$/.test(raw)){show('Enter a Canadian postal code, such as M5V 2T6. Use the recipient’s code rather than a sender’s ZIP code.',true);input.focus();return;}const code=raw.slice(0,3)+' '+raw.slice(3);button.disabled=true;show('Checking '+code+'…');const ctrl=new AbortController(),timer=setTimeout(()=>ctrl.abort(),15000);try{const r=await fetch('/a/multi/checkAddress',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({postcode:code,postal_code:code,country:'CA'}),signal:ctrl.signal});if(!r.ok)throw Error('Unavailable');const json=await r.json(),d=json.data,place=d?.resultAddressByPostalCode;if(!d||!['ship','local'].includes(d.type)||!place?.city)throw Error('Unconfirmed');const name=place.city+(place.state?', '+place.state:'');const message=d.type==='local'?'A local delivery route was returned. Eligible dates depend on the gift and the complete address.':'A courier route was returned'+(d.days?' with a general transit estimate of '+String(d.days).toLowerCase():'')+'. Transit starts after dispatch.';show(name+' · '+code+'. '+message+' Confirm the chosen product, available delivery date and charge at checkout before ordering. This lookup does not reserve a date or confirm alcohol eligibility.');}catch{show('The delivery service could not confirm this address just now. Check the postal code, try again, or contact BeerNGrub before choosing a delivery date.',true);}finally{clearTimeout(timer);button.disabled=false;}});const zone=document.querySelector('[data-origin-zone]');if(zone){const update=()=>{document.querySelectorAll('[data-clock-zone]').forEach(el=>{const tz=el.dataset.clockZone==='sender'?zone.value:el.dataset.clockZone;try{el.textContent=new Intl.DateTimeFormat('en-CA',{timeZone:tz,weekday:'short',month:'short',day:'numeric',hour:'numeric',minute:'2-digit',timeZoneName:'short'}).format(new Date());}catch{el.textContent='Select a time zone';}});};zone.addEventListener('change',update);update();setInterval(update,60000);}})();
/* BeerNGrub international drafts. Support hours are not delivery cutoffs. */
(function () {
  'use strict';
  const SOURCE_ZONE = 'America/Toronto';

  function partsAt(instant, zone) {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(instant);
    return Object.fromEntries(parts.filter(p => p.type !== 'literal').map(p => [p.type, p.value]));
  }

  function dateAt(instant, zone) {
    const p = partsAt(instant, zone);
    return `${p.year}-${p.month}-${p.day}`;
  }

  function wallTimeToInstant(date, hour, zone) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) throw new Error('Invalid date');
    const [year, month, day] = date.split('-').map(Number);
    const target = Date.UTC(year, month - 1, day, hour);
    let candidate = target;
    for (let i = 0; i < 4; i += 1) {
      const p = partsAt(new Date(candidate), zone);
      const asUtc = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
      const difference = target - asUtc;
      if (!difference) {
        if (dateAt(new Date(candidate), zone) !== date) throw new Error('Invalid date');
        return new Date(candidate);
      }
      candidate += difference;
    }
    throw new Error('Local time could not be resolved');
  }

  function supportWindow(date, visitorZone) {
    // Validate the visitor zone even when only ISO instants are requested.
    new Intl.DateTimeFormat('en', { timeZone: visitorZone }).format(new Date());
    return {
      date, sourceZone: SOURCE_ZONE, visitorZone,
      start: wallTimeToInstant(date, 8, SOURCE_ZONE),
      end: wallTimeToInstant(date, 20, SOURCE_ZONE)
    };
  }

  function displayInstant(instant, zone) {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: zone, weekday: 'short', year: 'numeric', month: 'short', day: 'numeric',
      hour: 'numeric', minute: '2-digit', timeZoneName: 'long'
    }).format(instant);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { SOURCE_ZONE, partsAt, dateAt, wallTimeToInstant, supportWindow, displayInstant };
  }
  if (typeof document === 'undefined') return;
  const select = document.querySelector('[data-origin-zone]');
  const output = document.querySelector('[data-support-local]');
  if (!select || !output) return;

  // The visitor may be travelling. Use the actual device zone, without inferring
  // billing country or silently selecting one nationwide time for a large country.
  try {
    const deviceZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (deviceZone) {
      if (![...select.options].some(option => option.value === deviceZone)) {
        const option = document.createElement('option');
        option.value = deviceZone;
        option.textContent = `Your device: ${deviceZone.replaceAll('_', ' ')}`;
        select.appendChild(option);
      }
      select.value = deviceZone;
    }
  } catch { /* An explicit, unselected choice remains usable. */ }

  function update() {
    if (!select.value) {
      output.textContent = 'Select your time zone to see the support hours where you are.';
      return;
    }
    try {
      const date = dateAt(new Date(), SOURCE_ZONE);
      const window = supportWindow(date, select.value);
      output.textContent = `For ${date} in Toronto: ${displayInstant(window.start, select.value)} to ${displayInstant(window.end, select.value)}. Selected time zone: ${select.value}.`;
      output.dataset.sourceDate = date;
      output.dataset.visitorZone = select.value;
      output.dataset.start = window.start.toISOString();
      output.dataset.end = window.end.toISOString();
    } catch {
      output.textContent = 'Local time is unavailable. Support hours are 8:00 a.m.–8:00 p.m. Eastern Time (America/Toronto).';
    }
  }
  select.addEventListener('change', update);
  update();
  select.dispatchEvent(new Event('change', { bubbles: true }));
  setInterval(update, 60000);
})();